import './cssdirect/App.css';
import Daily from './components/daily';
import City from './components/City';
import {useState, useEffect} from 'react'
import Loading from './Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'

function App() {
const [loading, setLoading] = useState(true)
const [city, setCity] = useState('Paris')
const [weatherData, setWeather] = useState([])
const [error, setError] = useState(false)

const getWeather = async() =>{
  setLoading(true)
  setError(false)
  try{
    const resp = await fetch(`https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=f8d957da06af592a1390c360ea801908&units=imperial`)
    if(resp.status!==200){
      setLoading(false)
      setError(true)
      console.log("Error")
    }
    else{
      const pResp = await resp.json()
      setWeather(pResp)
      setLoading(false)
    }
  }
  catch(err){
    console.log("ERRRRROOOORRRR")
    setError(true)
  }
}

const handleSubmit = (e) =>{
  e.preventDefault()
  console.log(city) 
  getWeather()
}    

useEffect(()=>{
  getWeather()
},[])

  if(loading==true){
    
    return <>
    <h1 className='title'>Monkey Wit Da Weather</h1>
    <City setCity={setCity} city={city}/>
    <Loading/>
    <h1 className="madeBy">Designed and Programmed by Het Patel</h1>
    </>
  }
  else if(error==true){
    return<>
    <h1 className='title'>Monkey Wit Da Weather</h1>
    <div className="allWrapper">
      <City setCity={setCity} city={city} handleSubmit={handleSubmit}/>
      <h1>Error</h1>
      </div>
    </>
  }
  else{
    return<>
      <h1 className='title'>Monkey Wit Da Weather</h1>
      <div className="allWrapper">
      <City setCity={setCity} city={city} handleSubmit={handleSubmit}/>
     <Daily {...weatherData} setCity={setCity} city={city} getWeather={getWeather} handleSubmit={handleSubmit}/>
      </div>
     <h1 className="madeBy">Designed and Programmed with <FontAwesomeIcon className="heart"icon={faHeart}/>, by Het Patel</h1>
     
    </>
  }
}

export default App;
